
var content = require("!!../../node_modules/.pnpm/registry.npmjs.org/@angular-devkit/build-angular/0.801.3_44e50361e6483feca70ce5ca9e128e0a/node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!../../node_modules/.pnpm/registry.npmjs.org/postcss-loader/3.0.0/node_modules/postcss-loader/src/index.js??embedded!../../node_modules/.pnpm/registry.npmjs.org/sass-loader/7.1.0_webpack@4.35.2/node_modules/sass-loader/lib/loader.js??ref--15-3!./variables.scss");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../node_modules/.pnpm/registry.npmjs.org/style-loader/0.23.1/node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../node_modules/.pnpm/registry.npmjs.org/@angular-devkit/build-angular/0.801.3_44e50361e6483feca70ce5ca9e128e0a/node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!../../node_modules/.pnpm/registry.npmjs.org/postcss-loader/3.0.0/node_modules/postcss-loader/src/index.js??embedded!../../node_modules/.pnpm/registry.npmjs.org/sass-loader/7.1.0_webpack@4.35.2/node_modules/sass-loader/lib/loader.js??ref--15-3!./variables.scss", function() {
		var newContent = require("!!../../node_modules/.pnpm/registry.npmjs.org/@angular-devkit/build-angular/0.801.3_44e50361e6483feca70ce5ca9e128e0a/node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!../../node_modules/.pnpm/registry.npmjs.org/postcss-loader/3.0.0/node_modules/postcss-loader/src/index.js??embedded!../../node_modules/.pnpm/registry.npmjs.org/sass-loader/7.1.0_webpack@4.35.2/node_modules/sass-loader/lib/loader.js??ref--15-3!./variables.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}